<template>
  <div class="card" v-if="section.keys.length > 0">
    <div class="card-header">
      <b-row>
        <div class="col-md-4">
          <span class="font-weight-bold mr-2">{{ section.label }}</span>
          <span>({{ decidedCount }} of {{ section.keys.length }} completed)</span>
        </div>
        <div class="col-md-4 text-center">Current</div>
        <div class="col-md-4 text-center">New</div>
      </b-row>
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item align-items-center" v-for="key in section.keys" :key="key">
        <b-row>
          <div class="col-md-4 d-flex align-items-center">{{ camelCaseToWords(key) }}</div>
          <div :class="{'col-md-4': needsDecision(key), 'col-md-8': !needsDecision(key), 'mt-md-0': true, 'mt-2': true }">
            <b-button class="w-100" :class="{'text-muted': isEmpty(masterData[key])}" @click="accept(key, masterData)" :variant="buttonVariant(key, masterData)">
              <font-awesome-icon :class="{'invisible': !decided(key) || !sourceAccepted(key, masterData)}" class="icon float-left mt-1 mr-1" icon="check"/>
              <font-awesome-icon class="icon float-right mt-1 ml-1 invisible" icon="check"/><!-- Balancing icon -->
              <span v-if="!decided(key) || sourceAccepted(key, masterData)">{{ format(masterData[key]) }}</span>
              <s v-else>{{ format(masterData[key]) }}</s>
            </b-button>
          </div>
          <div class="col-md-4 mt-md-0 mt-2" v-if="needsDecision(key)">
            <b-button class="w-100" :class="{'text-muted': isEmpty(machineData[key])}" @click="accept(key, machineData)" :variant="buttonVariant(key, machineData)">
              <font-awesome-icon :class="{'invisible': !decided(key) || !sourceAccepted(key, machineData)}" class="icon float-left mt-1 mr-1" icon="check"/>
              <font-awesome-icon class="icon float-right mt-1 ml-1 invisible" icon="check"/><!-- Balancing icon -->
              <span v-if="!decided(key) || sourceAccepted(key, machineData)">{{ format(machineData[key]) }}</span>
              <s v-else>{{ format(machineData[key]) }}</s>
            </b-button>
          </div>
        </b-row>
      </li>
    </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'MachineFileMergerData',
  props: {
    section: {
      type: Object,
      required: true,
    },
    masterData: {
      type: Object,
      required: true,
    },
    machineData: {
      type: Object,
      required: true,
    },
    mergedData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    decidedCount: function () {
      return this.section.keys.filter(key => this.decided(key)).length
    },
    allDecided () {
      return this.decidedCount === this.section.keys.length
    },
  },
  mounted () {
    this.$emit('onChange', this.allDecided)
  },
  methods: {
    needsDecision (key) {
      return !_.isEqual(this.masterData[key], this.machineData[key])
    },
    decided (key) {
      return this.mergedData[key] !== undefined
    },
    isEmpty (v) {
      return v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)
    },
    format (v) {
      if (this.isEmpty(v)) {
        return '<empty>'
      }
      if (Array.isArray(v)) {
        return v.filter(item => item !== null && item !== undefined && item !== '').join(', ')
      }
      return v.toString()
    },
    buttonVariant (key, source) {
      return this.decided(key) && this.sourceAccepted(key, source) ? 'success' : 'outline-dark'
    },
    sourceAccepted (key, source) {
      return _.isEqual(source[key], this.mergedData[key])
    },
    accept (key, source) {
      Vue.set(this.mergedData, key, source[key])
      this.$emit('onChange', this.allDecided, this.section)
    },
    camelCaseToWords (camelCaseString) {
      return camelCaseString
          .replace(/([A-Z])/g, ' $1')
          .replace(/^./, (matches) => matches.toUpperCase())
          .trim()
    }
  }
}
</script>
